import type { AxiosService } from "@/new_design/interfaces/axiosServiceInterface";
import api from "@/components/application/api/api";

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface TokenDecoded {
  id: string;
  sub: string;
  iat: number;
  exp: number;
}

export const createAuthRepository = (api: AxiosService) => {
  const signIn = async (payload: LoginPayload): Promise<LoginResponse> => {
    return await api.post<LoginResponse, LoginPayload>(
      "/auth/sign-in",
      payload
    );
  };

  const forgotPasswordRequest = async (email: string): Promise<void> => {
    return await api.post<void, any>("/forgot-password/request", {
      email,
      front_url: window.location.origin,
    });
  };

  const forgotPasswordVerify = async (token: string): Promise<void> => {
    return await api.get<void, { email: string }>(
      `/forgot-password/verify/${token}`
    );
  };

  const forgotPasswordReset = async (
    token: string,
    payload: { newPassword: string }
  ): Promise<void> => {
    return await api.post<void, { newPassword: string }>(
      `/forgot-password/reset/${token}`,
      payload
    );
  };

  return {
    signIn,
    forgotPasswordRequest,
    forgotPasswordVerify,
    forgotPasswordReset,
  };
};

export default createAuthRepository(api);
